<template>
  <div class="newsList">
    <div class="contentrows_box">
      <div class="head">
        <img src="@/assets/back.png" class="back" type="primary" @click="goBack">
      </div>
      <div style="margin: 20px 30px 0 30px;">
        <div class="title_box">
          <div class="title">基本信息</div>
        </div>

        <div>
          <el-form-item label="项目名称">
            <el-col>
              <el-input v-model="name" placeholder="请输入项目名称" clearable />
            </el-col>
          </el-form-item>

          <div class="tag_box" >

            <div class="in_label" >关键词</div>
            <div style="display:inline-block;">
              <el-tag
                  size="medium"
                  style="height:30px;"
                  :key="tag"
                  v-for="tag in dynamicTags"

                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)">
                {{tag}}
              </el-tag>
              <!--                <el-input-->
              <!--                    class="input-new-tag"-->
              <!--                    v-if="inputVisible"-->
              <!--                    v-model="inputValue"-->
              <!--                    ref="saveTagInput"-->
              <!--                    size="normal"-->
              <!--                    @keyup.enter.native="handleInputConfirm"-->
              <!--                    @blur="handleInputConfirm"-->
              <!--                >-->
              <!--                </el-input>-->
              <el-autocomplete
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  value-key="name"
                  :onkeyup="input= input.replace(/[ ]/g,'')"
                  :fetch-suggestions="querySearchSync"
                  placeholder="请输入类型"
                  :trigger-on-focus="false"
                  size="normal"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
              ></el-autocomplete>
              <el-button v-if="inputVisible" class="button-new-tag"  @click="handleInputConfirm">添加</el-button>
              <el-button v-else class="button-new-tag"  @click="showInput">添加类型</el-button>
            </div>


          </div>


          <el-form-item label="预投入资金">
            <el-col>
              <el-input type="number" v-model="needMoney" placeholder="请输入资金" clearable />
            </el-col>
<!--            <input type="number">-->
          </el-form-item>
          <el-form-item label="联系人">
            <el-col>
              <el-input v-model="contact" placeholder="请输入联系人" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系地址">
            <el-col>
              <el-input v-model="contactAddress" placeholder="请输入联系地址" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-col>
              <el-input v-model="contactNumber" placeholder="请输入联系电话" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="单位标识">
            <el-col>
              <el-input type="number" v-model="companyId" placeholder="请输入单位标识" clearable />
            </el-col>
          </el-form-item>
          <el-form-item label="意向合作方式">
            <el-col>
              <el-input v-model="manner" placeholder="请输入意向合作方式" clearable />
            </el-col>
          </el-form-item>
        </div>

        <div>
          <ckeditor :editor="editor" v-model="content" :config="editorConfig" :class="ck-editor__editable"></ckeditor>

        </div>
        <el-button type="success" @click="admit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import time from '@/core/time.js';
import ClassicEditor from "@/ckeditor/ckeditor";
import {ElLoading} from "element-plus";



export default {
  data() {
    return {
      name:'',
      content:'',
      type:'',
      id:'',
      input:'',
      manner:'',
      editor: ClassicEditor,
      needMoney:'',
      contact:'',
      contactAddress:'',
      contactNumber:'',
      companyId:'',
      companyName:'',

      dynamicTags: [],//关键词
      deletedTags: [],
      originTags: [],
      inputVisible: false,
      inputValue: '',
      result: [],//专用

      editorConfig: {
        min_height: 800,
        // The configuration of the editor.
        toolbar: ['heading', '|', 'bold', 'italic', 'alignment', 'link', 'bulletedList',
          'numberedList', 'blockQuote', 'outdent', 'indent' , '|', 'uploadImage', 'mediaEmbed','insertTable','|', 'undo', 'redo'],
        simpleUpload: {
          uploadUrl: '/api3/config/fileInfo/uploadImg',
          withCredentials: false,
        },
        mediaEmbed: {   // 视频配置
          previewsInData: true,
          providers: [
            {
              name: 'myprovider',
              url: [
                /^lizzy.*\.com.*\/media\/(\w+)/,
                /^www\.lizzy.*/,
                /(http|https):\/\/([\w.]+\/?)\S*/
              ],
              html: match => {
                //获取媒体url
                const input = match['input'];
                return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
                    // 'video controls="controls" autoplay name="media" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"'+
                    // `source src="${input}" type="video/mp4"`+
                    // '/video'+
                    `<iframe src="${input}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                );
              }
            }
          ]
        }

      },
      editorData: '',
      totalNum: 0, pageNum: 1, pageSize: 6,
      news: [],
    }
  },
  watch: {
    $route(to, from) {
      window.location.reload(); //监测到路由发生跳转时刷新一次页面
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.newsSelect();

    this.tagInit();
  },
  mounted() {
  },
  methods: {
    filter(){
      let data =this.id
      console.log(data+'*')
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});

      this.$request.post('/arRequirement/selectrequirement',data).then(data => {
        console.log(data)
        //debugger
        this.name=data.obj.arRequirement.name;
        this.content = data.obj.arRequirement.content;
        this.needMoney= data.obj.arRequirement.needMoney
        this.manner=  data.obj.arRequirement.manner
        this.type= data.obj.arRequirement.type
        this.contact= data.obj.arRequirement.contact
        this.contactAddress= data.obj.arRequirement.contactAddress
        this.contactNumber= data.obj.arRequirement.contactNumber
        this.companyId= data.obj.arRequirement.companyId
        this.date = time.formateDate(data.obj.arRequirement.createdDate);
        loadingInstance.close();
      })

    },
    tagInit(){
      if(this.id == undefined)
      {
        return 1;
      }
      let data = {
        id:this.id,
        type:2,
      }
      let url = '/keyword/getKeywordByAchiId';
      this.$request.post(url,data).then(data =>{
        console.log("222222222222222222"+data);
        for (var i = 0; i < data.obj.length; i++) {
          this.originTags[i] = data.obj[i].name;
          this.dynamicTags[i] = data.obj[i].name;
        }

      })
    },
    tagSearch(value){
      let tag = value;
      let url = '/keyword/getKeywordByArTag';
      this.$request.post(url,tag).then(data =>{
        console.log("22222222222222222222222222222222222222"+data);
        return data.obj;
      })
    },
    handleClose(tag) {
      if(this.originTags.indexOf(tag)!=-1){
        this.deletedTags.push(tag);
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if(this.inputValue==''){}

      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    querySearchSync(queryString, cb) {
      this.result=[];
      let tag = queryString;
      // console.log('================================',tag)
      let url = '/keyword/getKeywordByArTag';
      this.$request.post(url,tag).then(data =>{
        this.result.push({"name":queryString})
        for (var i = 0; i < data.obj.length; i++) {
          let name = data.obj[i].name
          if(name === queryString)continue;
          console.log('--------------',name,i)
          this.result.push({"name":name})
          // this.result.info[i] = "name:"+data.obj[i].name;
        }
        console.log("================",this.result)

        cb(this.result);
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   cb(data.obj);
        // }, 3000 * Math.random());
      })
      // var results = this.tagSearch(queryString);
      // console.log(results[1].name);
      //
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(results);
      // }, 3000 * Math.random());
    },
    admit() {
      if(this.name==''){
        this.$msg.warning('请输入需求项目名称')
      }else if(this.needMoney==''){
        this.$msg.warning('请输入预金额')
      }else if(this.contact==''){
        this.$msg.warning('请输入联系人')
      }else if(this.contactNumber==''){
        this.$msg.warning('请输入联系电话')
      }else if(this.manner==''){
        this.$msg.warning('请输入意向合作方式')
      }
      else if(this.contactAddress==''){
        this.$msg.warning('请输入联系人地址')
      }else if(this.content==''){
        this.$msg.warning('请输入正文')
      }else if(this.companyId==''){
        this.$msg.warning('请输入单位标识')
      }else {
        let data = {
          id: this.id,
          name: this.name,
          arTag :this.dynamicTags,
          deletedTag :this.deletedTags,
          content: this.content,
          needMoney: this.needMoney,
          manner:this.manner,
          contact: this.contact,
          contactAddress: this.contactAddress,
          contactNumber: this.contactNumber,
          companyId:this.companyId,
        }
        //debugger
        console.log(1111111,this.dynamicTags,this.deletedTags)
        console.log(11111111111111,data)
        let url = '/arRequirement/UpdateRequirement'
        this.$request.post(url, data).then(res => {
          console.log(res)
          if(this.$msg.success('提交成功')){
            this.$router.push({
              path:'/myRequirement',
              // query:{
              //   id:value.id,
              // }
            })
          }
        })

      }

    },

    newsSelect() {
      // let data = {
      console.log(this.id)
       let id=this.id;
      if(id!=''&&id!=null&&id!=undefined){
        console.log('no')
        let url = '/arRequirement/selectrequirement';
        this.$request.post(url, id).then(data => {
          this.name = data.obj.arRequirement.name;
          this.content = data.obj.arRequirement.content;
          this.needMoney=data.obj.arRequirement.needMoney;
          this.contact=data.obj.arRequirement.contact;
          this.contactAddress=data.obj.arRequirement.contactAddress;
          this.contactNumber=data.obj.arRequirement.contactNumber;
          this.companyId=data.obj.arRequirement.companyId;
          this.manner=data.obj.arRequirement.manner;
        })
      }

      console.log('--------')
      console.log(this.content+'-')
      // //debugger
    },
    showNews(value) {
      this.$router.push({
        path: '/newsShow',
        query: {
          id: value.id,
        }
      })
    },

  }
}
</script>
<style lang="less">

.ck-editor__editable {
  min-height: 500px;
  word-break:break-all;
}
.head{
  .back{
    margin-left: 30px;
    margin-top: 20px;
    width: 80px;
    height: 40px;
  }
  .back:hover{
    cursor: pointer;
  }
}

.newsList {
  width: 100%;
  height: 100%;
  background: white;

  .contentrows_box {
    height: 97%;
    border-radius: 20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;

    .contentrows {
      margin: auto;
      width: 860px;
      padding-top: 50px;

      .row_box {
        width: 860px;
      }

      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;

        .row_date {
          display: flex;
          float: left;
          width: 82px;

          .row_date_left {
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }

          .row_date_right {
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;

            .row_date_month {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }

            .row_date_year {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }

        .row_content {
          margin-top: 40px;
          line-height: 40px;
          height: 30px;
          padding-left: 20px;
          margin-left: 10px;
          width: 600px;
          float: left;
          border-left: 6px solid #CDD9E9;

          .row_title {
            overflow: hidden;
            width: 400px;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            float: left;
          }

          .row_title:hover {
            cursor: pointer;
          }

          .row_name {
            font-size: 13px;
            width: 200px;
            color: #a8a8ac;
            float: right;
            text-align: right;
          }
        }

        .el-button {
          background: #3A63B3;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius: 0;
          float: right;
        }
      }

    }
    .tag_box{
      margin-top: 20px;
      margin-bottom:20px;
      .el-tag + .el-tag {
        margin-left: 10px;
      }
      .button-new-tag {
        margin-left: 10px;
        height: 30px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
      }
      .input-new-tag {
        width: 180px;
        margin-left: 10px;
        height: 30px;
        line-height: 30px;
        vertical-align: bottom;
      }
      .in_label{
        margin-top:5px;
        display: inline-block;
        //float: left;
        //width: 190px;
        height: 20px;
        text-align: right;
        margin-right: 10px;
      }


      .row_box{
        display: inline-block;
        float: left;
        width: 200px;
        height: 20px;
      }
    }

    .page {
      height: 100px;
      width: 860px;
      margin: auto;
      position: relative;

      .el-pager {
        li {
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }

        li:not(.disabled).active {
          background-color: #3A62FE;
          color: white;
        }

        li:hover {
          color: #3A62FE;
        }
      }

      .btn-prev {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }

      .btn-next {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }

      .el-pagination {
        position: absolute;
        bottom: 30px;
        right: 0;

        .el-pagination__sizes {
          float: right;

          .el-input__inner {
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}

</style>
<!--<style language="less">-->

<!--.ck-editor__editable {-->
<!--  min-height: 400px;-->
<!--  word-break:break-all;-->
<!--}-->
<!--.head{-->
<!--  .back{-->
<!--    margin-left: 30px;-->
<!--    margin-top: 20px;-->
<!--    width: 80px;-->
<!--    height: 40px;-->
<!--  }-->
<!--  .back:hover{-->
<!--    cursor: pointer;-->
<!--  }-->
<!--}-->

<!--.newsList {-->
<!--  width: 100%;-->
<!--  height: 100%;-->
<!--  background: white;-->

<!--  .contentrows_box {-->
<!--    height: 90%;-->
<!--    border-radius: 20px;-->
<!--    background: white;-->
<!--    width: 95%;-->
<!--    margin-left: 2.5%;-->
<!--    margin-top: 2.5%;-->
<!--    box-shadow: 0px 0px 10px 0 #d0d2d3;-->

<!--    .contentrows {-->
<!--      margin: auto;-->
<!--      width: 860px;-->
<!--      padding-top: 50px;-->

<!--      .row_box {-->
<!--        width: 860px;-->
<!--      }-->

<!--      .row {-->
<!--        height: 80px;-->
<!--        width: 840px;-->
<!--        border-bottom: 2px dotted #D4D4DC;-->

<!--        .row_date {-->
<!--          display: flex;-->
<!--          float: left;-->
<!--          width: 82px;-->

<!--          .row_date_left {-->
<!--            height: 60px;-->
<!--            margin-top: 20px;-->
<!--            font-size: 35px;-->
<!--            line-height: 70px;-->
<!--          }-->

<!--          .row_date_right {-->
<!--            height: 40px;-->
<!--            margin-top: 34px;-->
<!--            padding-left: 5px;-->

<!--            .row_date_month {-->
<!--              height: 20px;-->
<!--              font-size: 14px;-->
<!--              line-height: 20px;-->
<!--            }-->

<!--            .row_date_year {-->
<!--              height: 20px;-->
<!--              font-size: 14px;-->
<!--              line-height: 20px;-->
<!--            }-->
<!--          }-->
<!--        }-->


<!--        .el-button {-->
<!--          background: #3A63B3;-->
<!--          height: 20px;-->
<!--          width: 80px;-->
<!--          margin-top: 45px;-->
<!--          margin-right: 30px;-->
<!--          font-size: 13px;-->
<!--          line-height: 2px;-->
<!--          border-radius: 0;-->
<!--          float: right;-->
<!--        }-->
<!--      }-->

<!--    }-->

<!--    .page {-->
<!--      height: 100px;-->
<!--      width: 860px;-->
<!--      margin: auto;-->
<!--      position: relative;-->

<!--      .el-pager {-->
<!--        li {-->
<!--          border: 1px solid #dcdfe6;-->
<!--          margin-right: 10px;-->
<!--          background-color: white;-->
<!--        }-->

<!--        li:not(.disabled).active {-->
<!--          background-color: #3A62FE;-->
<!--          color: white;-->
<!--        }-->

<!--        li:hover {-->
<!--          color: #3A62FE;-->
<!--        }-->
<!--      }-->

<!--      .btn-prev {-->
<!--        border: 1px solid #dcdfe6;-->
<!--        margin-right: 10px;-->
<!--        margin-left: 10px;-->
<!--        background-color: white;-->
<!--      }-->

<!--      .btn-next {-->
<!--        border: 1px solid #dcdfe6;-->
<!--        margin-right: 10px;-->
<!--        background-color: white;-->
<!--      }-->

<!--      .el-pagination {-->
<!--        position: absolute;-->
<!--        bottom: 30px;-->
<!--        right: 0;-->

<!--        .el-pagination__sizes {-->
<!--          float: right;-->

<!--          .el-input__inner {-->
<!--            color: #5D61AA;-->
<!--            font-weight: bold;-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->

<!--</style>-->
